import React, { useState, useRef, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import styles from '../styles/LeagueSettings.module.css';

// Easter egg messages for hidden content
const EASTER_EGG_MESSAGES = [
  "Nice Try",
  "Not Today",
  "Keep Guessing",
  "Hidden Treasure",
  "Secret Agent",
  "Undercover",
  "Classified",
  "Top Secret",
  "Need to Know",
  "Access Denied",
  "Try Again Later",
  "Mystery Solved?",
  "Elementary, My Dear",
  "The Game is Afoot",
  "Curiouser and Curiouser"
];

const HiddenText = ({
  type = 'locker',
  weekNumber = null,
  showTooltip = true,
  className = '',
  text = null,
  tooltip = null,
  ...props
}) => {
  const [showTooltipState, setShowTooltipState] = useState(false);

  const elementRef = useRef(null);
  const tooltipPositionRef = useRef({ top: 0, left: 0 });

  // Function to update tooltip position based on mouse position
  const updateTooltipPosition = useCallback((event) => {
    if (showTooltipState) {
      const newPosition = {
        top: event.clientY - 40,
        left: event.clientX
      };
      tooltipPositionRef.current = newPosition;
    }
  }, [showTooltipState]);

      // Update position on mouse move while tooltip is visible
  useEffect(() => {
    if (showTooltipState) {
      const handleMouseMove = (event) => updateTooltipPosition(event);
      window.addEventListener('mousemove', handleMouseMove);

      return () => {
        window.removeEventListener('mousemove', handleMouseMove);
      };
    }
  }, [showTooltipState, updateTooltipPosition]);

  // Generate a consistent but varied easter egg based on type and week
  const getEasterEgg = () => {
    const seed = type === 'locker' ? 1 : 2;
    const weekSeed = weekNumber || 0;
    const index = (seed + weekSeed) % EASTER_EGG_MESSAGES.length;
    return EASTER_EGG_MESSAGES[index];
  };

  const easterEgg = getEasterEgg();
  const displayText = text || easterEgg;
  const tooltipText = tooltip || (type === 'locker'
    ? `Hidden until Week ${weekNumber || 'X'} Lock is Confirmed`
    : 'Lock information is hidden');

  // Choose CSS class based on type for visual variety
  const cssClass = type === 'locker'
    ? styles.hiddenTextEasterEgg1
    : styles.hiddenTextEasterEgg2;

  const handleMouseEnter = (event) => {
    // Show tooltip first
    setShowTooltipState(true);

    // Then calculate position based on mouse position
    requestAnimationFrame(() => {
      if (elementRef.current) {
        // Use viewport coordinates (clientX/clientY) for consistency
        const newPosition = {
          top: event.clientY - 40,
          left: event.clientX
        };

        tooltipPositionRef.current = newPosition;
      }
    });
  };

  const handleMouseLeave = () => {
    setShowTooltipState(false);
  };

  if (showTooltip) {
    return (
      <>
        <span
          ref={elementRef}
          className={`${cssClass} ${className}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          {...props}
        >
          {displayText}
        </span>
                                {showTooltipState && createPortal(
          <div
            className={styles.floatingTooltip}
            style={{
              position: 'fixed',
              top: tooltipPositionRef.current.top,
              left: tooltipPositionRef.current.left,
              zIndex: 10000
            }}
          >
            {tooltipText}
          </div>,
          document.body
        )}

      </>
    );
  }

  return (
    <span className={`${cssClass} ${className}`} {...props}>
      {displayText}
    </span>
  );
};

export default HiddenText;
